export const navItems = [
  { label: "HOME", link: "/" },
  { label: "GOODIE BAG", link: "/goodiebag" },
  { label: "PREPARE", link: "/prepare" },
  { label: "FAQS", link: "/faqs" },
  { label: "CHARITY", link: "/charity" },
  { label: "CONTACT", link: "/contact" },
];
